import loopback from '@/services/loopback'

const INVITE_ELIGIBILITY_CACHE_TTL_MS = 300000

let cachedInviteEligibility = null
let cachedInviteEligibilityAt = null

function hasFreshCache () {
  if (cachedInviteEligibility === null) return false
  if (cachedInviteEligibilityAt === null) return false
  if (!Number.isInteger(cachedInviteEligibilityAt)) return false
  return Date.now() - cachedInviteEligibilityAt < INVITE_ELIGIBILITY_CACHE_TTL_MS
}

export function resolveInviteEligibilityMaxUsers (eligibility) {
  if (!eligibility) return null
  if (!Number.isInteger(eligibility.maxUsers)) return null
  if (eligibility.maxUsers <= 0) return null
  return eligibility.maxUsers
}

export function isAccountRestricted (eligibility) {
  if (!eligibility) return false
  return eligibility.reasonCode === 'ACCOUNT_RESTRICTED'
}

export function isOrganizationUserLimitExempt (organization) {
  if (organization === null || organization === undefined) {
    return false
  }
  if (typeof organization !== 'object') {
    return false
  }
  return organization.isUserLimitExempt === true
}

export async function getInviteEligibility ({ forceRefresh = false } = {}) {
  if (forceRefresh !== true && hasFreshCache()) return cachedInviteEligibility

  try {
    const eligibility = await loopback.get('/users/invite-eligibility')
    if (!eligibility) return null
    if (typeof eligibility.canInvite !== 'boolean') return null
    cachedInviteEligibility = eligibility
    cachedInviteEligibilityAt = Date.now()
    return eligibility
  } catch (err) {
    console.error('Error fetching invite eligibility:', err)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/services/invite-eligibility.js